import { array } from "@msuite/utils/array";
import React from "react";
import { CALENDAR_DAY_HOURS, CALENDAR_HOUR_HEIGHT } from "./shared";

export function CalendarDayContentInlay() {
	return (
		<React.Fragment>
			{array(CALENDAR_DAY_HOURS).map((id, index) => (
				<div
					className="flex-shrink-0 w-full border-b-[0.5px] border-b-dashed border-color p-2"
					style={{
						height: `${CALENDAR_HOUR_HEIGHT}px`,
					}}
					key={id}
				>
					<p className="text-[0.5rem] font-mono opacity-30">
						{index.toString().padStart(2, "0")}:00
					</p>
				</div>
			))}
		</React.Fragment>
	);
}
